import React, { useEffect, useRef, useState } from 'react'
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { AiOutlinePlus, AiOutlineCheck } from "react-icons/ai";
import axios from 'axios';
import { gettoken } from '../Localstorage/Store';
import { FaAngleDown } from "react-icons/fa";
import {  useSelector } from "react-redux";
import Accountprice from '../utils/Accountprice';

export const OrderHistorytwo = () => {
  const { bgColor, textColor } = useSelector((state) => state.theam);

  const statuses = [
    "Saved_Cart",
    "Saved_Cart_Order_Created",
    "Saved_Cart_Approved",
    "Saved_Cart_Rejected",
    "Quote_Requested",
    "Quotation_Shared",
    "Payment_Processing",
    "BULK_SAVED_CART_ORDER_CREATED"
  ];
const dayselect = useRef(null);

const openSelectBox = () => {
  if (dayselect.current) {
    dayselect.current.focus();
  }
};



const [dropdownVisible, setDropdownVisible] = useState(false);
const [dropdownVisibletwo, setDropdownVisibletwo] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('Select Duration');

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };
  const toggleDropdowntwo = () => {
    setDropdownVisibletwo(!dropdownVisibletwo);
  };

  const handleStatusSelect = (value, label) => {
    setSelectedStatus(label);
    setDropdownVisible(false); // Close the dropdown after selection
  };

const nvg = useNavigate()
  const [data, setData] = useState([]);
  const [error, seterror] = useState("No orders found !");

  

  const [datastatus, setDatastatus] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  console.log("selectedStatus", selectedStatuses)
  const [selectedDuration, setSelectedDuration] = useState(null);
  console.log(selectedDuration, "selectedDuration")




  const tokenvalue = gettoken();
  const [loading, setloading] = useState(false)
  const [filter1, setfilter1] = useState(false)
  const [filter2, setfilter2] = useState(false)
  const [filter3, setfilter3] = useState(false)
  const [filter4, setfilter4] = useState(false)
  const [filter5, setfilter5] = useState(false)
  const [filter6, setfilter6] = useState(false)
  const [filter7, setfilter7] = useState(false)
  const [color, setcolor] = useState(true)
  const [size, setsize] = useState(true)
  const [roderstatus, setroderstatus] = useState(true)
  const [owl, setowl] = useState('tab-1')
  const [filter, setfilter] = useState(true)
  const currentwdith = window.innerWidth;

  const clearfilter = () => {
    setfilter1(false)
    setfilter2(false)
    setfilter3(false)
    setfilter4(false)
    setfilter5(false)
    setfilter6(false)
    setfilter7(false)
  }





  const clearFilter = () => {
    setSelectedStatuses([]); 
    setSelectedDuration(null);
    fetchcategory() 
};

  useEffect(() => {
    async function fetchstatus() {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      let url = `${process.env.REACT_APP_API_URL}my_api/bulkordersstatus/`;

      const response = await axios.get(url, config);
      setDatastatus(response.data);
    }
    fetchstatus()

  }, [])
  const [searchTerm, setSearchTerm] = useState('');
  const handleSearch = async () => {
if(searchTerm == ''){
  fetchcategory()
}else{

    const filteredOrders = data.filter(order =>
      order.order_number.includes(searchTerm)
    );
    setData(filteredOrders)

    console.log('Filtered orders:', filteredOrders);
    if (data.length > 0 && selectedDuration) {
      if (selectedDuration == '360') {
        const errorMessage = "No orders found last one year "
        seterror(errorMessage);

      }   if (selectedDuration == '180') {
        const errorMessage = "No orders found last six Month "
        seterror(errorMessage);

      }
      if (selectedDuration == '30') {
        const errorMessage = "No orders found last 30 Days "
        seterror(errorMessage);

      }
      if (selectedDuration == '15') {
        const errorMessage = "No orders found last 15 Days "
        seterror(errorMessage);

      }
  
      
    
    }
}
    
  };


  const handleStatusChangewindow = async (status) => {
    if(status == ""){
      fetchcategory()
    }else{
    const updatedStatuses = [status];
    setSelectedStatuses(updatedStatuses);
    await sendDataToBackend(updatedStatuses, selectedDuration);
  }
  };
  const handleStatusChange = async (status) => {
    const updatedStatuses = selectedStatuses.includes(status)
      ? selectedStatuses.filter(s => s !== status)
      : [...selectedStatuses, status];
    setSelectedStatuses(updatedStatuses);
    await sendDataToBackend(updatedStatuses, selectedDuration);
  };

  const handleCheckboxChange = async (duration) => {
    setSelectedDuration(duration);
    await sendDataToBackend(selectedStatuses, duration); 
  };

  const sendDataToBackend = async (statuses, duration) => {


    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
      },
    };
    console.log("check stat us",statuses);
    const url = `${process.env.REACT_APP_API_URL}bulk/bulk-orders-nor/?${duration ? `duration=${duration}&`:''}${statuses[0] ? `status=${statuses[0]}`:''}`; 
    const response = await axios.get(url, config); 

    console.log("response from backend:", response);
    setData(response.data);
  };
  async function fetchcategory() {
    setloading(true)
    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
      },
    };
    // let url = `${process.env.REACT_APP_API_URL}my_api/ordersstatus/`;
    let url = `${process.env.REACT_APP_API_URL}bulk/bulk-orders-nor/`;

    // let url = `${process.env.REACT_APP_API_URL}api/orders/`;
    const response = await axios.get(url, config);
    console.log("order history response", response)
    console.log("order history response data", response.data)

    setData(response.data);
    setloading(false)
  }
  useEffect(() => {
   
    fetchcategory()

  }, [])

  const dropdownRef = useRef(null);
  const dropdownReftwo = useRef(null);

  

  useEffect(() => {
    const handleClickOutsidetwo = (event) => {
      if (dropdownReftwo.current && !dropdownReftwo.current.contains(event.target)) {
        setDropdownVisibletwo(false); // Close dropdown if clicked outside
      }
    };

    // Add event listener to detect clicks outside
    document.addEventListener('mousedown', handleClickOutsidetwo);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutsidetwo);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false); // Close dropdown if clicked outside
      }
    };

    // Add event listener to detect clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div>
      <Header />

      <div>
        {/* breadcrumb start */}
        <div className="breadcrumb-main marginfromtop" style={{ background: "#fff" }}>
          <div className="container m-0">
            <div className="row">
              <div className="col">
                <div className="breadcrumb-contain">
                  <div>
                    <ul>
                      <li><a href="/home">home</a></li>
                      <li>{`>`}</li>
                      <li><a href="javascript:void(0)">Order History</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* breadcrumb End */}
        <div>
          <section className="section-big-pt-space py-1 " style={{ background: "#f9f9f9" }}>
            <div className="col-lg-12 col-sm-12 col-xs-12 mt-lg-4 mt-xs-4 mb-5">

              <div className="container-fuild emp-profile">
                <div className="row pro">


                  {/* <div id="tab-2" style={{ display: owl == 'tab-2' ? 'block' : 'none' }} className={owl == 'tab-2' ? "tab-content active default product-block3" : "tab-content product-block3"}> */}
                  <div className="row py-xl-4 py-3 d-flex justify-content-center" >



                    <div className={ "col-xl-9 col-md-12 Ohistory "} style={{ padding: "0px 4px" }} >
                      <div className="input-group mb-3" style={{ gap: '10px',alignItems:'end' }}>
                       
                        <input
                          type="text"
                          style={{ borderRadius: "0px",letterSpacing:'1px',height:'fit-content',fontSize:'14px' }}
                          className="form-control newsizeinput"
                          placeholder="Search your orders id here"
                          aria-label="Recipient's username"
                          
                          aria-describedby="button-addon2"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)} // Update searchTerm state as user types
                        />
                        <button
                          className='Sbtn btn btn-outline-secondary'
                          style={{ backgroundColor: `#${bgColor}`, color: 'white', borderRadius: '0px',height:'fit-content', fontSize: "14px" }}
                          type="button"
                          id="button-addon2"
                          onClick={handleSearch} // Call handleSearch function when the button is clicked
                        >
                          <i className="fa fa-search"></i>&nbsp; Search
                        </button>
                      </div>
                      

                      <div className="table-responsive customoverflow" >
                        <table className="table  orstatus" >

                          {/* <table className="table"> */}
                          <thead>
                            <tr>
<th></th>
<th></th>
                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>S.No</div></th>
                              

                              <th scope="col" style={{width:"20%",position:'relative'}}><div style={{
                                fontWeight: 600, fontSize: "12px", display: "flex",alignItems:'end',
                                WebkitLineClamp: "1",
                                // position:'absolute',
                                // height:'80%',
                                // width:'100%',
                                background:'#fff',
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}> <p style={{height:'fit-content',fontSize:'12px'}}> Order Date <label htmlFor="daydropdown" style={{margin:'0px'}} onClick={toggleDropdown} ><FaAngleDown /></label></p></div>   
                              {dropdownVisible && (
              <ul style={dropdownStyle} ref={dropdownRef}>
                <li onClick={() => handleCheckboxChange('15')}>Last 15 Days</li>
                <li onClick={() => handleCheckboxChange('30')}>Last 30 Days</li>
                <li onClick={() => handleCheckboxChange('180')}>Last 6 Months</li>
                <li onClick={() => handleCheckboxChange('360')}>Last 1 Year</li>
              </ul>
            )}
                              </th>

<th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Order Id</div></th>


                              {/* <th scope="col"><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Total Quantity</div></th>
                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Payment Mode</div></th> */}
                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Amount</div></th>

                              <th scope="col"style={{position:'relative'}} ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                display: "flex",alignItems:'end',
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}> <p style={{height:'fit-content',fontSize:'12px'}} > Order Status <label htmlFor="daydropdown" style={{margin:'0px'}} onClick={toggleDropdowntwo} ><FaAngleDown /></label> </p></div>
                              {dropdownVisibletwo && (
              <ul style={dropdownStyle} ref={dropdownReftwo}>

{datastatus.map((statusData, index) => (
                                      
                 <li style={{display:statuses.includes(statusData.status) ? "none" : 'block'}} onClick={() => handleStatusChangewindow(statusData.status)}>{statusData.status == "Bulk_Order_Created" ? "Order Created" : ''}</li>

                                  ))}
               
              </ul>
            )}
                              </th>
                            
                            </tr>
                          </thead>
                          {/* </table> */}



                          <thead className="table-light" style={{ paddingTop: '20px' }}>
                            <tr>

                            </tr>
                          </thead>
                          <tbody >
                            {data[0] ? (data.map((item, index) => (
                              <tr  key={index}>
<td></td>
<td></td>

                                <td style={{ color: '#0cb744', paddingTop: '20px', fontSize: '12px' }}>

                                  <h5 style={{ fontSize: "12px", lineHeight: "22px",cursor:'pointer',position:'relative',left:'7px' }}> {index + 1}</h5>
                                </td>

                                <td style={{ paddingTop: '20px', fontSize: '12px', }}> <p className='superwidth234' style={{margin:'0px',padding:'0px',fontSize: '12px'}}> {new Date(item?.order_date.split('Time')[0]).toLocaleDateString('en-GB', {
                                  hour: 'numeric',
                                  minute: 'numeric'
                                }


                                )}</p></td>
                                <td style={{ color: '#0cb744', paddingTop: '20px', fontSize: '12px' }}>

                                  <h5 onClick={() => { item.status == "Quotation_Shared" ? nvg(`/order-request/${item.order_number}`) : nvg(`/order-history-detail/${item.order_number}`) }} style={{ fontSize: "12px", lineHeight: "22px",color: `#${textColor}`,cursor:'pointer' }}> {item.order_number}</h5>
                                </td>
                               





                                <td style={{ paddingTop: '20px', fontSize: '12px' }}>
                                  {Accountprice(item.total_incl_tax)}</td>

                                <td>
                                  <p style={{ paddingTop: '15px', fontSize: '12px' }} className='superwidth234'> 
                                   
                                    {item.status == "Bulk_Order_Created" ? "Order Created" : ""}
                                  </p>
                                </td>
                              

                              </tr>
                            ))) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  className="text-center"
                                  style={{ fontWeight: "500" }}
                                >
                                  {error}
                                </td>
                              </tr>
                            )}



                          </tbody>
                        </table>
                      </div>

                    </div>

                  </div>






                </div>
              </div>
            </div>
          </section>

        </div>


        <div
          className="modal fade"
          id="exampleModalfour"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          style={{ zIndex: 9383838 }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-xl" style={{ position: 'relative', bottom: '0px', margin: "0px", alignItems: 'flex-end', height: '100vh' }}>
            <div className="modal-content" style={{ flexDirection: 'column-reverse' }}>
              <div className="modal-header mod-line">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  style={{ backgroundImage: "none", fontSize: '12px', margin: '0px', width: '44%', opacity: 1, height: "auto", border: "1px solid #b5b5b5" }}
                >Cancel</button>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  style={{ fontSize: '12px', backgroundImage: "none", margin: '0px', width: '44%', backgroundColor: "#4150b5", opacity: 1, height: "auto", color: "white" }}
                >Apply</button>
              </div>
              <div className="modal-body">
                <div className="filterheader d-flex justify-content-between">
                  <h5 style={{ fontSize: '12px' }}>Filters</h5>
                  <h5 style={{ color: "#acacac", fontSize: '12px' }} onClick={clearFilter}>Clear Filters</h5>
                </div>
                <div className="orderstatus py-3">
                  <h6 className='py-2' style={{ fontSize: '12px' }}>Order Status</h6>
                  <div className="odr-btn d-flex" style={{ flexWrap: 'wrap', gap: "12px" }}>
    {datastatus.map((statusData, index) => (
        <div key={`status-${index}`} style={{ marginBottom: '5px' }}>
            <input
                type="checkbox"
                id={`status-${index}`}
                onChange={() => handleStatusChange(statusData.status)}
                checked={selectedStatuses.includes(statusData.status)}
                style={{ display: 'none' }} 
            />
            <label
                htmlFor={`status-${index}`}
                style={{
                    border: "1px solid #b5b5b5",
                    padding: '3px 9px',
                    borderRadius: '20px',
                    backgroundColor: selectedStatuses.includes(statusData.status) ? "#4150b5" : "white",
                    color: selectedStatuses.includes(statusData.status) ? "#fff" : "#000", // Text color
                    fontSize: '11px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {statusData.status}
                {selectedStatuses.includes(statusData.status) ? (
                    <AiOutlineCheck style={{ marginLeft: '5px' }} />
                ) : (
                    <AiOutlinePlus style={{ marginLeft: '5px' }} />
                )}
            </label>
        </div>
    ))}
</div>
                </div>
                <div className="orderstatus py-3">
                  <h6 className='py-2' style={{ fontSize: '12px' }}>Order Time</h6>
                  <div className="odr-btn d-flex" style={{ flexWrap: 'wrap', gap: "12px" }}>
            <div
                onClick={() => handleCheckboxChange('15')}
                style={{
                    border: "1px solid #b5b5b5",
                    padding: '3px 9px',
                    borderRadius: '20px',
                    backgroundColor: selectedDuration === '15' ? "#4150b5" : "white",
                    color: selectedDuration === '15' ? "#fff" : "black",
                    fontSize: '13px',
                    cursor: 'pointer'
                }}
            >
                Last 15 Days {selectedDuration === '15' ? <AiOutlineCheck /> :""}
            </div>

            <div
                onClick={() =>handleCheckboxChange('30')}
                style={{
                    border: "1px solid #b5b5b5",
                    padding: '3px 9px',
                    borderRadius: '20px',
                    backgroundColor: selectedDuration === '30' ? "#4150b5" : "white",
                    color: selectedDuration === '30' ? "#fff" : "black",
                    fontSize: '13px',
                    cursor: 'pointer'
                }}
            >
                Last 30 Days {selectedDuration === '30' ? <AiOutlineCheck /> :""}
            </div>

            <div
                onClick={() => handleCheckboxChange('180')}
                style={{
                    border: "1px solid #b5b5b5",
                    padding: '3px 9px',
                    borderRadius: '20px',
                    backgroundColor: selectedDuration === '180' ? "#4150b5" : "white",
                    color: selectedDuration === '180' ? "#fff" : "black",
                    fontSize: '13px',
                    cursor: 'pointer'
                }}
            >
                Last 6 Months {selectedDuration === '180' ? <AiOutlineCheck /> :""}
            </div>

            <div
                onClick={() => handleCheckboxChange('360')}
                style={{
                    border: "1px solid #b5b5b5",
                    padding: '3px 9px',
                    borderRadius: '20px',
                    backgroundColor: selectedDuration === '360' ? "#4150b5" : "white",
                    color: selectedDuration === '360' ? "#fff" : "black",
                    fontSize: '13px',
                    cursor: 'pointer'
                }}
            >
                Last 1 Year {selectedDuration === '360' ? <AiOutlineCheck /> : ""}
            </div>
        </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>


    </div>
  )
}


const dropdownStyle = {
  listStyle: 'none',
  margin: 0,
  padding: '10px',
  backgroundColor: '#fff',
  fontSize:'12px',
  border: '1px solid #ccc',
  position: 'absolute',
  top: '100%',
  left: 0,
  width: '150px',
  zIndex: 1,
  cursor: 'pointer',
};
export default OrderHistorytwo;
